import { validatePhoneNumber, validatePrefix } from 'utils/PhoneNumberUtils';

/**
 * Validate phone number object
 * @param {import('utils/PhoneNumberUtils').PhoneNumber} phoneNumber
 * @param {import('./interventions/details/types').ValidationMeta} meta
 * @param {boolean} localRequired
 */
export const phoneNumberValidator = (phoneNumber = {}, meta, localRequired) => {
  const phoneNumberData = {
    ...phoneNumber,
    local: phoneNumber.local?.toString() ?? '',
    prefix: phoneNumber.prefix?.toString() ?? '',
  };

  const isValidPrefix = validatePrefix(phoneNumberData);
  if (!isValidPrefix) {
    return { prefix: meta.intl.formatMessage({ id: 'page.fiche.error.form.prefix', defaultMessage: 'The prefix of phone number is wrong.' }) };
  }

  const shouldCheckLocal = !localRequired ? phoneNumberData.local?.length === 0 : false;
  const isValid = shouldCheckLocal || validatePhoneNumber(phoneNumberData);
  if (!isValid) {
    return { local: meta.intl.formatMessage({ id: 'page.fiche.error.form.phoneNumber', defaultMessage: 'The phone number is invalid.' }) };
  }

  return undefined;
};
